// Imports

import React from 'react';
import Tooltip from '../Tooltip';

// Macros

import ValidationErrors from 'scripts/macros/ValidationErrors';

// Helpers

import checkForError from 'scripts/helpers/checkForInputError';

// Component : Text Area

class TextInput extends React.Component {
	// Blur Event

	async blurEvent(event) {
		const element = event.target;
		const name = element.getAttribute('name');
		const errorList = this.props.data.errors;
		const errorInfo = Array.isArray(errorList) ? await checkForError(element, errorList) : { isValid: true };

		this.props.parentEvent(name, element.value, [
			{
				name: 'valid',
				value: errorInfo.isValid,
			},
			{
				name: 'error',
				value: !errorInfo.isValid,
			},
			{
				name: 'activeError',
				value: errorInfo.error ? errorInfo.error.name : null,
			},
		]);
	}

	// Focus Event

	focusEvent(event) {
		const element = event.target;
		const name = element.getAttribute('name');

		this.props.parentEvent(name, element.value, [
			{
				name: 'error',
				value: false,
			},
			{
				name: 'valid',
				value: false,
			},
		]);
	}

	// Change Event

	changeEvent(event) {
		const element = event.target;
		const name = element.getAttribute('name');

		this.props.parentEvent(name, element.value, [
			{
				name: 'valid',
				value: false,
			},
			{
				name: 'error',
				value: false,
			},
		]);
	}

	// Render

	render() {
		const data = this.props.data;
		const state = this.props.state.fields.find((entry) => entry.name === data.name);

		return (
			<input-wrapper required={state && state.required} valid={state && state.valid} error={state && state.error}>
				<label>
					<span>{data.label}</span>
				</label>

				<Tooltip text={data.tooltip}>
					<input
						type={data.type ? data.type : 'text'}
						value={state.value}
						placeholder={data.placeholder}
						name={data.name}
						disabled={state.disabled ? state.disabled : false}
						onChange={this.changeEvent.bind(this)}
						onBlur={this.blurEvent.bind(this)}
						onFocus={this.focusEvent.bind(this)}
					/>
				</Tooltip>

				<ValidationErrors errorList={data.errors} activeError={state.activeError} />
			</input-wrapper>
		);
	}
}

export default TextInput;
